import { useQuery } from 'react-query';
import { CONFIG } from '@frontend/config';
import { client } from '@frontend/features/common/services';

export interface HotelBookingPermission {
  connector_account_id: string;
  bookings_enabled: boolean;
}
export function useHotelBookingPermissions() {
  return useQuery(
    ['hotel-booking-permissions', Number(CONFIG.AGENCY_ID)],
    async () => (await client.get<{ data: HotelBookingPermission[] }>('hotels/booking-permissions')).data.data,
    { retry: false, staleTime: 0, refetchOnMount: 'always' },
  );
}
export function accountCanBook(accounts: HotelBookingPermission[] | undefined, accountId: string | undefined) {
  return (
    !!accountId &&
    accounts?.some((account) => account.connector_account_id === accountId && account.bookings_enabled === true) ===
      true
  );
}
